import React from 'react';
import { Panel, Label } from '@uhg-harmony/uitk-react';
import { Arrow } from 'builder/scenes/SiteBuilder/SettingsPanel/SettingsPanel';
import {
  SizeLocationData,
  WidgetSizeLocation,
} from '../../../../builder/components/WidgetSizeLocation';
import { Config } from './types';
import { Border } from 'builder/components/WidgetConfigurations/Border';
import FileUploaderPanel from 'builder/components/WidgetConfigurations/FileUploader/FileUploaderPanel';
import {
  SizeLocationPanel,
  StyledPanel,
  StyledPanelTitle,
} from '../../Text/TextWidgetControl';

const FileUploaderWidgetControl: React.FC<WidgetControlProps<Config>> = (
  props: WidgetControlProps<Config>
) => {
  const {
    value,
    onChange,
    widgetState,
    currentPage: { layoutLocked },
  } = props;

  const handleLineColor = data => {
    onChange({
      ...value,
      lineColor: data,
    });
  };

  const updateWidgetSizeLocation = (sizeLoc: SizeLocationData) => {
    onChange({
      ...value,
      width: sizeLoc.width,
      height: sizeLoc.height,
      xLocation: sizeLoc.xLocation,
      yLocation: sizeLoc.yLocation,
      uniqueId: sizeLoc.uniqueId,
    });
  };

  const updateBorderData = (data: BorderData) => {
    onChange({
      ...value,
      borderData: data,
    });
  };

  const handleFieldLabel = (data: string) => {
    onChange({
      ...value,
      label: data,
    });
  };

  const determineNumberOfEnabledFileTypes = (
    ...fileTypes: boolean[]
  ): number => {
    return fileTypes.filter(Boolean).length;
  };

  const updateAcceptedFileTypes = (key: string, data: boolean) => {
    onChange({
      ...value,
      [key]: data,
    });
  };

  return (
    <>
      <Panel.Group>
        <StyledPanel>
          <Panel
            title={<Label style={StyledPanelTitle}>General</Label>}
            icon={Arrow}
          >
            <FileUploaderPanel
              data-test-id="file-uploader-panel"
              handleFieldLabel={handleFieldLabel}
              updateAcceptedFileTypes={updateAcceptedFileTypes}
              determineNumberOfEnabledFileTypes={
                determineNumberOfEnabledFileTypes
              }
              widgetState={widgetState}
            />
          </Panel>
        </StyledPanel>
        <StyledPanel>
          <SizeLocationPanel
            title={<Label style={StyledPanelTitle}>Size and Location</Label>}
            initiallyClosed
            icon={Arrow}
            data-test-id="authentication-panel"
          >
            <WidgetSizeLocation
              data-test-id="widget-size-location"
              disabled={layoutLocked}
              sizeLocation={{
                xLocation: value.xLocation,
                yLocation: value.yLocation,
                width: value.width,
                height: value.height,
                uniqueId: value.uniqueId,
              }}
              updateWidgetSizeLocation={updateWidgetSizeLocation}
              activeWidgetId={widgetState.id}
            />
          </SizeLocationPanel>
        </StyledPanel>
        <StyledPanel>
          <Panel
            title={<Label style={StyledPanelTitle}>Border</Label>}
            initiallyClosed
            icon={Arrow}
          >
            <Border
              data-test-id="border-data"
              updateBorderData={updateBorderData}
              disabled={layoutLocked}
              handleLineColor={handleLineColor}
              widgetState={widgetState}
              pages={props.pages}
              site={props.site}
              updateSite={props.updateSite}
              saveSite={props.saveSite}
            />
          </Panel>
        </StyledPanel>
      </Panel.Group>
    </>
  );
};

export default FileUploaderWidgetControl;
